<template>
  <div :class="[mainClassName, 'quote']" >
    <div class="quotes">
      <div class="quotes__icon">
        <single-quote-svg></single-quote-svg>
      </div>
      <div class="quotes__icon">
        <single-quote-svg></single-quote-svg>
      </div>
    </div>
    {{ value }}
  </div>
</template>
<script>
import SingleQuoteSvg from 'static/svg/icon_single_quote_blue.svg'

export default {
  name: 'quoteBlock',
  components: {
    SingleQuoteSvg,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    quoteType: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    mainClassName() {
      switch (this.quoteType) {
        case 'default':
          return 'blockquote-quote'
        case 'author':
          return 'blockquote-author'
        default: {
          return 'blockquote-quote'
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .quote {
    position: relative;
    background-color: $white;
  }
  .quote-container {
    font-family: $barlow;
  }
  .blockquote-quote {
    font-size: rem-calc(26);
    line-height: rem-calc(33);
    font-style: italic;
    border-image: linear-gradient(to right, $rose, $waterspout);
    border-image-slice: 1;
    border-style: solid;
    border-width: rem-calc(3) 0 0 0;
    margin-top: rem-calc(50);
    padding: rem-calc(20 10);
    color: $rose;
    font-family: $barlow;
    font-weight: bold;

    .quotes {
      position: absolute;
      top: rem-calc(-33);
      left: rem-calc(10);
      width: rem-calc(80);
      height: rem-calc(44);

      &__icon {
        display: inline-block;
        position: relative;
        width: rem-calc(35);
        margin-right: rem-calc(3);

        &:first-child {
          svg {
            fill: #76FFFF;
            animation: quoteFlickering 1s step-start infinite alternate;
          }
        }

        &:last-child {
          svg {
            fill: #18FFFF;
            animation: quoteFlickeringReverse 1s step-start infinite alternate;
          }
        }
      }
    }
  }

  .blockquote-author {
    @include respond-to('desktop') {
      font-size: rem-calc(14);
      line-height: rem-calc(21);
      font-weight: initial;
    }
    @include respond-to('mobile') {
      font-size: rem-calc(14);
      line-height: rem-calc(16);
    }
    color: $dark-turquoise2;
    padding: rem-calc(0 10 20);
    text-transform: uppercase;
    z-index: 2;

    .quotes {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// QuoteBlock.vue?1053adfb